const extractCssVariableName = (token: string): string | null => {
  const trimmed = token.trim();
  if (!trimmed) {
    return null;
  }

  if (trimmed.startsWith('var(')) {
    const match = trimmed.match(/var\((--[^,\)\s]+)(?:,[^\)]*)?\)/);
    return match?.[1] ?? null;
  }

  if (trimmed.startsWith('--')) {
    return trimmed;
  }

  return null;
};

const resolveCssVariable = (
  variableName: string,
  styles: CSSStyleDeclaration | null,
  visited: Set<string>,
): string | null => {
  if (!variableName) {
    return null;
  }

  if (visited.has(variableName)) {
    return null;
  }

  visited.add(variableName);

  const resolved = styles?.getPropertyValue(variableName).trim();
  if (!resolved) {
    return null;
  }

  const nestedVariable = extractCssVariableName(resolved);
  if (nestedVariable) {
    return resolveCssVariable(nestedVariable, styles, visited) ?? resolved;
  }

  return resolved;
};

export const resolveColorToken = (
  token: string | null | undefined,
  styles: CSSStyleDeclaration | null,
): string | null => {
  if (typeof token !== 'string') {
    return token == null ? null : `${token}`;
  }

  const trimmedToken = token.trim();
  if (!trimmedToken) {
    return trimmedToken;
  }

  const cssVariableName = extractCssVariableName(trimmedToken);
  if (!cssVariableName) {
    return trimmedToken;
  }

  return resolveCssVariable(cssVariableName, styles, new Set()) ?? trimmedToken;
};

export default resolveColorToken;
